// Shown while a single paper is being evaluated.
// The animation differs between Scholar (hourglass) and Alien (radar)
// themes to maintain the personality of each mode.

import React from 'react';
import type { Theme } from '../types';
import ThemeToggle from './ThemeToggle';
import loadingStyles from '../styles/LoadingState.module.css';

const LOADING_STEPS = [
  'Parsing PDF...',
  'Reading the abstract...',
  'Checking the math...',
  'Judging the jargon...',
  'Writing the verdict...',
];

interface LoadingStateProps {
  filename: string;
  theme: Theme;
  onToggleTheme: () => void;
}

export default function LoadingState({ filename, theme, onToggleTheme }: LoadingStateProps) {
  return (
    <div className={loadingStyles.page}>
      <h1 className={loadingStyles.title}>Desk Reject</h1>
      <p className={loadingStyles.filename}>Evaluating {filename}</p>

      <div className={loadingStyles.steps}>
        {LOADING_STEPS.map((msg, i) => (
          <div key={i} className={loadingStyles.step}>
            <div className={loadingStyles.dot} />
            <span className={loadingStyles.stepText}>{msg}</span>
          </div>
        ))}
      </div>

      {theme === 'scholar' ? (
        <div className={loadingStyles.hourglassWrap}>
          <div className={loadingStyles.hourglassTop} />
          <div className={loadingStyles.hourglassNeck} />
          {Array.from({ length: 10 }, (_, i) => (
            <div
              key={i}
              className={`${loadingStyles.sandDrop} ${loadingStyles[`sandDrop${i + 1}` as keyof typeof loadingStyles]}`}
            />
          ))}
          <div className={loadingStyles.hourglassBottom} />
        </div>
      ) : (
        <div className={loadingStyles.radar}>
          <div className={`${loadingStyles.radarRing} ${loadingStyles.radarRing1}`} />
          <div className={`${loadingStyles.radarRing} ${loadingStyles.radarRing2}`} />
          <div className={`${loadingStyles.radarRing} ${loadingStyles.radarRing3}`} />
          <div className={loadingStyles.radarSweep} />
          <div className={loadingStyles.radarPing} />
          <div className={loadingStyles.radarDot} />
        </div>
      )}

      <ThemeToggle theme={theme} onToggle={onToggleTheme} />
    </div>
  );
}